import { render, staticRenderFns } from "./FileView.vue?vue&type=template&id=18a13f2c&"
import script from "./FileView.vue?vue&type=script&lang=ts&"
export * from "./FileView.vue?vue&type=script&lang=ts&"
import style0 from "./FileView.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports